import { firebaseReducer } from 'react-redux-firebase';
import { combineReducers, Reducer } from 'redux';
import { PersistPartial } from 'redux-persist/es/persistReducer';

import { IAddressBookState } from '../../types/addressBook';
import { IAuthState } from '../../types/auth';
import { IAutomationsState } from '../../types/automations';
import { IBucketState } from '../../types/bucket';
import { ICampaignsState } from '../../types/campaigns';
import { ICreateSendState } from '../../types/createSend';
import { IDashboardState } from '../../types/dashboard';
import { IFulfillmentCentersState } from '../../types/fulfillmentCenters';
import { IIntegrationsState } from '../../types/integrations';
import { IInventoriesState } from '../../types/inventories';
import { IModalState } from '../../types/modals';
import { IOneLinksState } from '../../types/oneLink';
import { IOrganizationsState } from '../../types/organizations';
import { IReasonsState } from '../../types/reasons';
import { IReportsState } from '../../types/reports';
import { IShellState } from '../../types/shell';
import { ISnackbarState } from '../../types/snackbar';
import { ITemplatesState } from '../../types/templates';
import { IToolsState } from '../../types/tools';
import { IUsersState } from '../../types/users';
import createSend from '../createSend';
import addressBook from './addressBook';
import auth from './auth';
import automations from './automations';
import bucket from './bucket';
import campaigns from './campaigns';
import dashboard from './dashboard';
import fulfillmentCenters from './fulfillmentCenters';
import integrations from './integrations';
import inventories from './inventories';
import modals from './modals';
import oneLink from './oneLink';
import organizations from './organizations';
import reasons from './reasons';
import reports from './reports';
import shell from './shell';
import snackbar from './snackbar';
import templates from './templates';
import tools from './tools';
import users from './users';

export interface IAppState {
  auth: IAuthState;
  bucket: IBucketState;
  dashboard: IDashboardState;
  modals: IModalState;
  integrations: IIntegrationsState;
  campaigns: ICampaignsState;
  createSend: ICreateSendState & PersistPartial;
  inventories: IInventoriesState;
  reports: IReportsState;
  oneLink: IOneLinksState;
  templates: ITemplatesState;
  users: IUsersState;
  automations: IAutomationsState;
  reasons: IReasonsState;
  organizations: IOrganizationsState;
  shell: IShellState;
  tools: IToolsState;
  fulfillmentCenters: IFulfillmentCentersState;
  addressBook: IAddressBookState;
  snackbar: ISnackbarState;
  firebase: any;
}

const rootReducer: Reducer<IAppState> = combineReducers({
  auth,
  dashboard,
  modals,
  integrations,
  campaigns,
  createSend,
  inventories,
  bucket,
  reports,
  oneLink,
  templates,
  users,
  reasons,
  organizations,
  shell,
  tools,
  fulfillmentCenters,
  addressBook,
  firebase: firebaseReducer,
  automations,
  snackbar,
});

export default rootReducer;
